<h2 class="titleDel" mat-dialog-title>{{'MAPP-VMS-DELETE.TITLE' | translate}}</h2>
<mat-dialog-content class="deleteVisitDialog">
    {{'MAPP-VMS-DELETE.GROUP' | translate}}
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="deleteVisitButton" mat-button mat-dialog-close>{{'MAPP-VMS-DELETE.CANCEL' | translate}}</button>
    <button class="deleteVisitButton" mat-button (click)="deleteVisit()">{{'MAPP-VMS-DELETE.DELETE' | translate}}</button>
</mat-dialog-actions>
<empusa-mat-spinner-overlay *ngIf="loading" overlay="true"></empusa-mat-spinner-overlay>
